export default __webpack_public_path__ + "static/media/type2-icon.22367a2e.png";